import { buildCloudPayQuery } from '../utils/query';


export const getCustomerBySubscriber = buildCloudPayQuery(
  ({ email, name, paymentMethod }) => ({
    force: true,
    url: `/paymentMethods/${paymentMethod}/customers/create`,
    options: {
      method: 'POST'
    },
    body: {
      name
    }
  })
);
